import script from "./save-period-set-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./save-period-set-modal.vue?vue&type=script&setup=true&lang=ts"

import "./save-period-set-modal.vue?vue&type=style&index=0&id=f5d23fcb&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5d23fcb"]])

export default __exports__